module.exports = __webpack_public_path__ + "img/ekyc_frame_poa_2.d85e17d6.svg";